<template>
  <v-card>
    <v-card-title>
      Create Event
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid" ref="form">
        <v-text-field
          label="Event Name"
          color="primary"
          :rules="nameRules"
          v-model="formData.name"
          required></v-text-field>

        <v-menu
          lazy
          :close-on-content-click="false"
          v-model="menu"
          transition="scale-transition"
          offset-y
          full-width
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            label="Event date"
            color="primary"
            v-model="date"
            prepend-icon="event"
            :rules="required"
            readonly
          ></v-text-field>
          <v-date-picker color="primary" v-model="date" no-title scrollable actions :allowed-dates="checkDate">
            <template slot-scope="{ save, cancel }">
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat  @click="cancel">Cancel</v-btn>
                <v-btn flat color="primary" @click="save">OK</v-btn>
              </v-card-actions>
            </template>
          </v-date-picker>
        </v-menu>

        <v-text-field
          v-model="time"
          mask="##:##"
          label="Event time"
          required
          prepend-icon="access_time"
          :rules="timeRule"
        />

        <v-radio-group v-model="formData.type" :rules="typeRule" v-if="!event">
          <v-radio color="primary" label="NFL Games" :value="0"></v-radio>
          <v-radio color="primary" label="NCAA Games" :value="1"></v-radio>
          <v-radio color="primary" label="Other Event" :value="2"></v-radio>
        </v-radio-group>
      </v-form>
    </v-card-text>
    <v-alert color="error" icon="warning" v-if="err" :value="err !== ''">
      {{err}}
    </v-alert>
    <v-layout column align-end class="px-2">
      <a
        @click.prevent="submit"
        class="modal-button black--text"
        :disabled="!valid">
        <v-btn :disabled="!valid" fab dark small color="primary">
          <v-icon dark>arrow_forward</v-icon>
        </v-btn>
        Submit
      </a>  
      <a
        @click.prevent="$emit('close')"
        class="modal-button black--text">
        <v-btn fab dark small color="accent">
          <v-icon dark>close</v-icon>
        </v-btn>
        Close
      </a>
    </v-layout>
  </v-card>
</template>

<script>
  import moment from 'moment';
  import webHelper from '../../helpers/web';

  export default {
    props: ['event', 'index'],
    data: () => ({
      date: null,
      time: null,
      start: null,
      menu: false,
      menu2: false,
      valid: true,
      eventDates: [],
      formData: {
        name: '',
        type: null,
      },
      timeRule: [v => /^([01]\d|2[0-3]):?([0-5]\d)$/.test(v) || 'Invalid time'],
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 35) || 'Name must be less than 35 characters',
      ],
      typeRule: [
        v => [0, 1, 2].includes(v) || 'Type is required',
      ],
      required: [
        v => !!v || 'Required',
      ],
      err: '',
    }),
    methods: {
      formatTime(time) {
        return `${time.slice(0, 2)}:${time.slice(2)}`;
      },
      checkDate(date) {
        return !this.eventDates.includes(date);
      },
      async submit() {
        if (!this.valid) return;
        const date = `${this.date} ${this.formatTime(this.time)}:00`;
        this.formData.start = date;
        if (this.event) {
          this.formData.id = this.event._id;
        }
        const method = this.event ? 'put' : 'post';
        const res = await webHelper[method](this, 'event', this.formData);
        if (res.failed) {
          this.err = 'Failed to create event';
          return;
        }
        this.formData._id = this.event ? this.event._id : res.id;
        const storeEvent = this.event ? 'editEvent' : 'pushEvent';
        this.formData.start = `${this.date} ${this.formatTime(this.time)}`;
        const data = this.event ? { event: this.formData, index: this.index } : this.formData;
        this.$store.dispatch(storeEvent, data);
        this.$emit('close');
      },
    },
    async created() {
      if (this.event) {
        this.date = moment(this.event.start).format('YYYY-MM-DD');
        this.time = moment(this.event.start).format('HHmm');
        this.formData.name = this.event.name;
        this.formData.type = this.event.type;
      }
      const res = await webHelper.get(this, 'event');
      if (res.failed) {
        this.err = 'Failed to fetch events. Taken dates won\'t be shown';
        return;
      }
      this.eventDates = res.events.map(event => moment(event.start).format('YYYY-MM-DD'));
      if (this.date) {
        this.eventDates = this.eventDates.filter(date => date !== this.date);
      }
    },
  };
</script>

<style>
  .modal-button {
    min-width: 105px;
  }
  .vdatetime,
  .vdatetime-input {
    width: 100%;
  }
  .vdatetime-input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgba(0,0,0,.54) !important;
    opacity: 1; /* Firefox */
  }

  .vdatetime-input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: rgba(0,0,0,.54) !important;
  }

  .vdatetime-input::-ms-input-placeholder { /* Microsoft Edge */
    color: rgba(0,0,0,.54) !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/modals/Event.vue